import { Button, Card, Input, Row, message } from "antd";
import { useState } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

const { TextArea } = Input;

const FeedbackCard = () => {
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState("");
    const { t } = useTranslation();

    const sendFeedback = async () => {
        setLoading(true);

        if (feedback) {
            try {
                await HTTPClient.post("/feedback/", { feedback });
                message.success(t("profile.feedback_card.success"));
            } catch (e) {
                message.error(t("profile.feedback_card.error"));
            }
        }
        setLoading(false);
        setFeedback("");
    };

    return (
        <>
            <Card
                style={{
                    width: "100vw",
                    maxWidth: "100%",
                    minWidth: "wrap-content",
                }}
                title={"Feedback"}>
                <h4>{t("profile.feedback_card.title")}</h4>
                <TextArea
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    autoSize={{
                        minRows: 6,
                        maxRows: 8,
                    }}
                />
                <Row style={{ marginTop: "2em", flexDirection: "row-reverse" }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        onClick={() => sendFeedback()}
                        loading={loading}>
                        {t("profile.feedback_card.call_to_action")}
                    </Button>
                </Row>
            </Card>
        </>
    );
};

export { FeedbackCard };
